import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";
import { useServicosProdutosListaViewModel } from "../../viewModels/servicos_produtos_lista_view_model";
import { Breadcrumbs, Typography, Link, Stack, TablePagination } from "@mui/material";
import { Header } from "./components/header";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { useMemo } from "react";
import { GenerateServicosProdutosColumnDefinition } from "./columns";
import { ServicoProdutoLista } from "../../../domain/models/servico_produto_lista";
import { ServicosProdutosModal } from "./components/servicos_produtos_modal";
import { ReportViewerModal } from "../../../../../common/components/report_viewer_modal";
import { ChangeHistoryModal } from "../../../../../common/modals/change_history_modal";

import RefreshButton from "../../../../../common/components/refresh_button";
import AlertError from "../../../../../common/components/alert_error";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import PrimaryButton from "../../../../../common/components/primary_button";
import DeleteDialog from "../../../../../common/components/delete_dialog";

/**
 * ServicosProdutosLista
 */

export const ServicosProdutosLista = () => {
  const viewModel = useServicosProdutosListaViewModel();

  const columnsDefinition = useMemo(() => {
    return GenerateServicosProdutosColumnDefinition({
      onActionEditar: viewModel.handleServicosProdutosModalOpenState,
      onActionDelete: viewModel.handleServicoProdutoDeleteModalOpenState,
    });
  }, [
    viewModel.handleServicosProdutosModalOpenState,
    viewModel.handleServicoProdutoDeleteModalOpenState,
  ]);

  return (
    <>
      {/**
        * PageTopBar
        */}

      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex flex-row gap-2">
              <div className="w-[135px]">
                <PrimaryButton
                  buttonColor="yellow"
                  onMouseDown={e => {
                    viewModel.handleServicoProdutosReports();
                    e.preventDefault();
                  }}>
                  Relatório
                </PrimaryButton>
              </div>

              <div className="w-[175px]">
                <PrimaryButton
                  buttonColor="red"
                  onMouseDown={e => {
                    viewModel.handleInativarSelecionadosSubmit();
                    e.preventDefault();
                  }}>
                  Inativar Selecionados
                </PrimaryButton>
              </div>

              <div className="w-[115px]">
                <PrimaryButton
                  startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                  onMouseDown={e => {
                    viewModel.handleServicosProdutosModalOpenState(null, true);
                    e.preventDefault();
                  }}>
                  Novo Item
                </PrimaryButton>
              </div>
            </div>
          }
        />
      </PageTopBar>

      {/**
        * Page
        */}

      <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
        <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
          <Link underline="hover" color="inherit">
            Compras
          </Link>
          <Typography className="text-primary-green">
            Produtos e Serviços
          </Typography>
        </Breadcrumbs>

        <div className="flex flex-col gap-2">
          <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
            <div className="flex gap-2 items-center w-full">
              <h1 className="text-3xl font-medium text-black dark:text-white">Produtos e Serviços</h1>
              <RefreshButton onClick={viewModel.handleReload} />
            </div>

            <div className="w-full justify-end flex gap-2">
            </div>
          </div>
        </div>
        {
          viewModel.errorMessage !== undefined
            ? (
              <div className="w-full">
                <AlertError
                  messageErro={viewModel.errorMessage}
                  onTryAgain={viewModel.handleReload} />
              </div>
            ) : (
              <>
                <Header
                  field={viewModel.filtros.field}
                  fieldValue={viewModel.filtros.fieldValue}
                  tipo={viewModel.filtros.tipo}
                  status={viewModel.filtros.status}
                  onFieldChange={viewModel.handleFieldChange}
                  onFieldValueChange={viewModel.handleFieldValueChange}
                  onTipoChange={viewModel.handleTipoChange}
                  onStatusChange={viewModel.handleStatusChange}
                  onClearFilters={viewModel.handleClearFilters}
                />

                <Stack spacing={0}>
                  <TablePagination
                    component="div"
                    count={viewModel.pagination.totalItems}
                    page={viewModel.pagination.page - 1}
                    onPageChange={(_, p) => viewModel.handlePageChange(p)}
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    rowsPerPage={viewModel.pagination.rowsPerPage}
                    onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
                  />

                  <StyledDataGrid
                    tableName="ServicosProdutos_lista"
                    disableColumnMenu={false}
                    getRowId={(row: ServicoProdutoLista) => row.idProdutoServico}
                    checkboxSelection={true}
                    columns={columnsDefinition}
                    loading={viewModel.loading}
                    disableRowSelectionOnClick={true}
                    rows={viewModel.produtosServicos}
                    rowCount={viewModel.produtosServicos.length}
                    rowSelectionModel={viewModel.rowSelectionModel}
                    onRowSelectionModelChange={viewModel.handleRowSelectionModel}
                    pageSizeOptions={[10, 25, 50, 100]}
                    paginationMode="server"
                    paginationModel={{
                      page: viewModel.pagination.page,
                      pageSize: viewModel.pagination.rowsPerPage,
                    }}
                  />

                  <TablePagination
                    component="div"
                    count={viewModel.pagination.totalItems}
                    page={viewModel.pagination.page - 1}
                    onPageChange={(_, p) => viewModel.handlePageChange(p)}
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    rowsPerPage={viewModel.pagination.rowsPerPage}
                    onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
                  />

                </Stack>
              </>
            )
        }
      </div>

      {/**
        * Modals
        */}

      <ServicosProdutosModal
        open={viewModel.servicosProdutosModal}
        saving={viewModel.saving}
        loading={viewModel.loading}
        selectedProdutoServico={viewModel.selectedProdutoServico}
        onClose={() => viewModel.handleServicosProdutosModalOpenState(null, false)}
        onSubmit={viewModel.handleServicosProdutosSubmit}
        onOpenChangeHistory={viewModel.handleOpenChangeHistory}
      />

      <DeleteDialog
        open={viewModel.servicosProdutosDeleteModal}
        title='Você realmente deseja excluir este item?'
        onClose={() => viewModel.handleServicoProdutoDeleteModalOpenState(null, false)}
        onDelete={() => viewModel.handleServicoProdutoDeleteSubmit()}
      />

      <ChangeHistoryModal
        changeHistoryHandler={viewModel.changeHistory}
      />

      <ReportViewerModal
        reportViewerState={viewModel.reportViewerState}
      />

    </>
  );
}